<template>
  <div>
    <h3>个人信息</h3>
    <div class="code">
      <div class="time clearfix">
        <div class="name">原密码：</div>
        <div class="stripsss">
          <el-input type="password" v-model="yuanpassword" placeholder="输入原始密码" class="text" ></el-input>
        </div>
      </div>
      <div class="time clearfix">
        <div class="name">新密码：</div>
        <div class="stripsss">
          <el-input type="password" v-model="newpassword" placeholder="输入新密码" class="text"></el-input>
        </div>
      </div>
      <div class="time clearfix">
        <div class="name">确认密码：</div>
        <div class="stripsss">
          <el-input type="password" v-model="quepassword" placeholder="再次确认密码" class="text"></el-input>
        </div>
      </div>
      <div class="time clearfix">
        <div class="name"></div>
        <div class="stripsss" @click="modify">
          <span>保存</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Upload, Input,Message } from "element-ui";
import utilFile from "@/ace/ace.js";
export default {
  components: {
    [Input.name]: Input,
    [Message.name]: Message,
  },
  data() {
    return {
      yuanpassword: null,
      newpassword: null,
      quepassword: null
    };
  },
  methods: {
    tuichu() {
      //退出登录
      this.$axios({
        method: "post",
        url: `/api/authority.logout`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 200) {
          setTimeout(() => {
            this.$router.replace({
              path: "/logins"
            });
          }, 1000);
        }
      });
    },
    modify() {
      if (
        this.yuanpassword != null &&
        this.newpassword != null &&
        this.quepassword != null
      ) {
        if (this.newpassword == this.quepassword) {
          var data = utilFile.encrypt(
            JSON.stringify({
              oldpwd: this.yuanpassword,
              newpwd: this.newpassword
            })
          );

          this.$axios({
            method: "post",
            url: `/api/authority.modifypwd?parameter=${data}`,
            data: {},
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
            }
          }).then(res => {
            if (res.data.code == 200) {
              Message.closeAll();
              Message({
                showClose: true,
                message: res.data.msg,
                type: "success"
              });
              this.tuichu();
            } else {
              Message.closeAll();
              Message({
                showClose: true,
                message: res.data.msg,
                type: "warning"
              });
            }
          });
        } else {
          Message.closeAll();
          Message({
            showClose: true,
            message: "密码不一致",
            type: "warning"
          });
        }
      } else {
        Message.closeAll();
        Message({
          showClose: true,
          message: "不能为空",
          type: "warning"
        });
      }
    }
  }
};
</script>

<style scoped>
h3 {
  font-size: 16px;
  color: #000;
  padding-bottom: 20px;
  border-bottom: 1px solid #edf1f2;
  margin-top: 26px;
}

.avatar-uploader {
  width: 100%;
  height: 100%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 100%;
  height: 100%;
  display: block;
}

.code {
  box-sizing: border-box;
  padding-left: 183px;
  padding-top: 67px;
}

.code .time {
  margin-bottom: 56px;
}

.code .time .name {
  font-size: 14px;
  color: #000;
  margin-right: 18px;
  float: left;
  line-height: 33px;
  width: 70px;
  text-align: right;
}

.code .stripsss {
  float: left;
  cursor: pointer;
}

.code .stripsss .headerimg {
  width: 102px;
  height: 102px;
  overflow: hidden;
  margin-left: 54px;
}

.code .text {
  width: 320px;
  height: 33px;
  line-height: 33px;
}

.code .stripsss span {
  display: block;
  width: 90px;
  line-height: 36px;
  background-color: #38a0ff;
  color: #ffffff;
  border-radius: 50px;
  text-align: center;
  margin-left: 90px;
}
</style>
<style>
.code .text .el-input__inner {
  height: 33px;
  line-height: 33px;
}
</style>